import React, { createContext, useContext, useEffect, useMemo, useState } from "react";

const STORAGE_KEY = "uido_themes";

const defaultState = {
  isMatrixEnabled: false,
};

const ThemeContext = createContext({
  ...defaultState,
  toggleMatrix: () => {},
  setMatrixEnabled: (_value) => {},
});

export const ThemeProvider = ({ children }) => {
  const [isMatrixEnabled, setMatrixEnabled] = useState(defaultState.isMatrixEnabled);

  useEffect(() => {
    try {
      const saved = localStorage.getItem(STORAGE_KEY);
      if (saved) {
        const parsed = JSON.parse(saved);
        if (typeof parsed.isMatrixEnabled === "boolean") setMatrixEnabled(parsed.isMatrixEnabled);
      }
    } catch (_) {}
  }, []);

  useEffect(() => {
    try {
      const toSave = JSON.stringify({ isMatrixEnabled });
      localStorage.setItem(STORAGE_KEY, toSave);
    } catch (_) {}
  }, [isMatrixEnabled]);

  useEffect(() => {
    const body = document.body;
    body.classList.toggle("theme-matrix", isMatrixEnabled);
    // Auto-disable matrix after 5 seconds when enabled
    let timerId;
    if (isMatrixEnabled) {
      timerId = window.setTimeout(() => {
        try { setMatrixEnabled(false); } catch {}
      }, 5000);
    }
    return () => clearTimeout(timerId);
  }, [isMatrixEnabled]);

  // Matrix auto-enable moved to ModeActivationOverlay to show pre-activation overlay

  const value = useMemo(
    () => ({
      isMatrixEnabled,
      toggleMatrix: () => {
        setMatrixEnabled((v) => !v);
        // Attempt to play audio immediately on user-initiated toggle
        try {
          const el = document.getElementById('matrix-audio');
          if (el && typeof el.play === 'function') {
            el.play().catch(() => {
              const resume = async () => { try { await el.play(); } catch {};
                window.removeEventListener('pointerdown', resume);
                window.removeEventListener('keydown', resume);
              };
              window.addEventListener('pointerdown', resume, { once: true });
              window.addEventListener('keydown', resume, { once: true });
            });
          }
          // Also notify listeners explicitly
          try { window.dispatchEvent(new Event('matrix:play-now')); } catch {}
        } catch (_) {}
      },
      setMatrixEnabled,
    }),
    [isMatrixEnabled]
  );

  return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>;
};

export const useTheme = () => useContext(ThemeContext);


